import { render, staticRenderFns } from "./updateExpense.vue?vue&type=template&id=0451274c"
import script from "./updateExpense.vue?vue&type=script&lang=js"
export * from "./updateExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports